import { Navigation, PageLayout } from "@src/components";
import { Slippage } from "./Slippage";
import { BackArrowIcon } from "@src/assets";
import { RoutePath } from "@src/interfaces";

export const SettingsView = () => {
  return (
    <PageLayout
      navigation={
        <Navigation
          leftItems={[
            {
              content: <BackArrowIcon />,
              path: RoutePath.Wallet,
            },
            {
              content: "Settings",
              disabled: true,
              path: RoutePath.Settings,
            },
          ]}
        />
      }
    >
      <div className="flex flex-col gap-5">
        <Slippage />
      </div>
    </PageLayout>
  );
};
